import styles from './SachaInventory.module.sass'
import Image from "next/image";
import cn from "classnames";
import {useGameContext} from "@/context/GameContext";

const SachaInventory = ({className, ...props}) => {

	const {isMobile} = useGameContext();

	  return (
			  <div className={cn(styles.sacha__container, className)} {...props}>
				  {isMobile !== undefined ? (isMobile
					  ? <Image className={styles.sacha}
					  src={'/Global/sacha_idleing.png'}
					  alt={"Sacha Idleing"}
					  quality={100}
					  width={64}
					  height={64}
					  />
						  : <Image className={styles.sacha}
				         src={'/Global/sacha_idleing.gif'}
				         alt={"Sacha Idleing"}
				         quality={100}
				         width={64}
				         height={64}
				  />) : null}
				  <div className={styles.svg_container}>
					  <svg xmlns="http://www.w3.org/2000/svg"
					       width="67"
					       height="8"
					       viewBox="0 0 67 8"
					       fill="none"
					       className={styles.top_shadow}>
						  <path d="M67 2.97617V4.42849H64.6661V5.61904H62.3323V6.21425H57.6671V6.80946H55.3332V7.40479H52.9994V8H14.0006V7.40479H11.6668V6.80946H9.33288V6.21425H4.66774V5.61904H2.33387V4.42849H0V2.97617H2.33387L2.33907 1.78575H4.67814V1.19042H9.35627V0.595211H14.0344V0H52.9656V0.595211H57.6437V1.19042H62.3219V1.78575H64.6609L64.6661 2.97617H67Z"
						        fill="#9F9A7C"/>
					  </svg>
					  <svg xmlns="http://www.w3.org/2000/svg"
					       width="86"
					       height="15"
					       viewBox="0 0 86 15"
					       fill="none"
					       className={styles.bottom_shadow}>
						  <path d="M86 5.58033V8.30343H83.0043V10.5357H80.0086V11.6517H74.0205V12.7677H71.0248V13.884H68.0291V15H17.9709V13.884H14.9752V12.7677H11.9795V11.6517H5.99143V10.5357H2.99571V8.30343H0V5.58033H2.99571L3.00239 3.34829H6.00477V2.23204H12.0095V1.11602H18.0143V0H67.9857V1.11602H73.9904V2.23204H79.9952V3.34829H82.9976L83.0043 5.58033H86Z"
						        fill="#C0BB9A"/>
					  </svg>
				  </div>
			  </div>
	  );
}
export default SachaInventory;